module.exports = __webpack_public_path__ + "img/icon_referidos_at_hover.3cd6d48a.svg";